export function getPaymentStatusIcon(paymentStatus: string): string {
    switch (paymentStatus) {
        case "PAID":
            return "mdi-cash-check";
        case "CANCELLED":
        case "FAILED":
            return "mdi-cash-remove";
        case "REFUNDED":
            return "mdi-cash-sync";
        case "PAYMENT_REQUESTED":
            return "mdi-cash-clock";
        case "FREE":
            return "mdi-sale";
        case "UNKNOWN":
            return "mdi-crosshairs-question";
        default:
            return "";
    }
}
